"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANDIDATE_USER_ROLES = exports.EMPLOYER_USER_ROLES = void 0;
var EMPLOYER_USER_ROLES;
(function (EMPLOYER_USER_ROLES) {
    EMPLOYER_USER_ROLES["ADMINISTRATOR"] = "Administrator";
    EMPLOYER_USER_ROLES["INTERNAL_RECRUITER"] = "EmployerRecruiter";
    EMPLOYER_USER_ROLES["CONTRIBUTOR"] = "Contributor";
})(EMPLOYER_USER_ROLES = exports.EMPLOYER_USER_ROLES || (exports.EMPLOYER_USER_ROLES = {}));
var CANDIDATE_USER_ROLES;
(function (CANDIDATE_USER_ROLES) {
    CANDIDATE_USER_ROLES["CONSUMER"] = "Consumer";
})(CANDIDATE_USER_ROLES = exports.CANDIDATE_USER_ROLES || (exports.CANDIDATE_USER_ROLES = {}));
